import { IIsiDtoPresentationLogicResponse } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IIsiDataTransferObject } from "./Isilog.IsiFramework.IsiDataTransferObject";
import { IsiDataTransferObject } from "./Isilog.IsiFramework.IsiDataTransferObject";
import { IsiDtoPresentationLogicResponse } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IIsiDtoPresentationLogicRequest } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IsiDtoPresentationLogicRequest } from "./Isilog.IsiComponent.IsiDataTransferObject";

export interface IIsiDtoPlXmlUserSettingsResponse extends IIsiDtoPresentationLogicResponse  {
    result?: IIsiDtoPlXmlUserSettingsResult;
}
export interface IIsiDtoPlXmlUserSettingsResult extends IIsiDataTransferObject  {
    value?: string;
}
export class IsiDtoPlXmlUserSettingsResult extends IsiDataTransferObject implements IIsiDtoPlXmlUserSettingsResult {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.PresentationLogic.XmlUserSettings.IsiDtoPlXmlUserSettingsResult, Isilog.IsiComponent.IsiDataTransferObject";
    value?: string;

    constructor(data?: IIsiDtoPlXmlUserSettingsResult) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoPlXmlUserSettingsResult): IsiDtoPlXmlUserSettingsResult {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlXmlUserSettingsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data;
    }
}
export class IsiDtoPlXmlUserSettingsResponse extends IsiDtoPresentationLogicResponse implements IIsiDtoPlXmlUserSettingsResponse {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.PresentationLogic.XmlUserSettings.IsiDtoPlXmlUserSettingsResponse, Isilog.IsiComponent.IsiDataTransferObject";
    result?: IsiDtoPlXmlUserSettingsResult;

    constructor(data?: IIsiDtoPlXmlUserSettingsResponse) {
        super(data);
        if (data) {
            this.result = data.result && !(<any>data.result).toJSON ? new IsiDtoPlXmlUserSettingsResult(data.result) : <IsiDtoPlXmlUserSettingsResult>this.result;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.result = _data["result"] ? IsiDtoPlXmlUserSettingsResult.fromJS(_data["result"]) : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoPlXmlUserSettingsResponse): IsiDtoPlXmlUserSettingsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlXmlUserSettingsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["result"] = this.result != null ? (<any>this.result).toJSON() : <any>null;
        return data;
    }
}
export interface IIsiDtoPlXmlUserSettingsRequest extends IIsiDtoPresentationLogicRequest  {
    xmlClientCtrlValue?: string;
    xmlClientTriggerId?: string;
    xmlClientCtrlId?: string;
    xmlClientCtrlValues?: string;
    xmlType?: string;
    actions?: string;
    response?: IIsiDtoPlXmlUserSettingsResponse;
}
export class IsiDtoPlXmlUserSettingsRequest extends IsiDtoPresentationLogicRequest implements IIsiDtoPlXmlUserSettingsRequest {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.PresentationLogic.XmlUserSettings.IsiDtoPlXmlUserSettingsRequest, Isilog.IsiComponent.IsiDataTransferObject";
    xmlClientCtrlValue?: string;
    xmlClientTriggerId?: string;
    xmlClientCtrlId?: string;
    xmlClientCtrlValues?: string;
    xmlType?: string;
    actions?: string;
    response?: IsiDtoPlXmlUserSettingsResponse;

    constructor(data?: IIsiDtoPlXmlUserSettingsRequest) {
        super(data);
        if (data) {
            this.response = data.response && !(<any>data.response).toJSON ? new IsiDtoPlXmlUserSettingsResponse(data.response) : <IsiDtoPlXmlUserSettingsResponse>this.response;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.xmlClientCtrlValue = _data["xmlClientCtrlValue"] !== undefined ? _data["xmlClientCtrlValue"] : <any>null;
            this.xmlClientTriggerId = _data["xmlClientTriggerId"] !== undefined ? _data["xmlClientTriggerId"] : <any>null;
            this.xmlClientCtrlId = _data["xmlClientCtrlId"] !== undefined ? _data["xmlClientCtrlId"] : <any>null;
            this.xmlClientCtrlValues = _data["xmlClientCtrlValues"] !== undefined ? _data["xmlClientCtrlValues"] : <any>null;
            this.xmlType = _data["xmlType"] !== undefined ? _data["xmlType"] : <any>null;
            this.actions = _data["actions"] !== undefined ? _data["actions"] : <any>null;
            this.response = _data["response"] ? IsiDtoPlXmlUserSettingsResponse.fromJS(_data["response"]) : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoPlXmlUserSettingsRequest): IsiDtoPlXmlUserSettingsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlXmlUserSettingsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["xmlClientCtrlValue"] = this.xmlClientCtrlValue !== undefined ? this.xmlClientCtrlValue : <any>null;
        data["xmlClientTriggerId"] = this.xmlClientTriggerId !== undefined ? this.xmlClientTriggerId : <any>null;
        data["xmlClientCtrlId"] = this.xmlClientCtrlId !== undefined ? this.xmlClientCtrlId : <any>null;
        data["xmlClientCtrlValues"] = this.xmlClientCtrlValues !== undefined ? this.xmlClientCtrlValues : <any>null;
        data["xmlType"] = this.xmlType !== undefined ? this.xmlType : <any>null;
        data["actions"] = this.actions !== undefined ? this.actions : <any>null;
        data["response"] = this.response != null ? (<any>this.response).toJSON() : <any>null;
        return data;
    }
}
